var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceRecognizedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "53px",
    viewBox: "0 0 51 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HSP-Dashboard-_dark-Copy",
    transform: "translate(-118.000000, -987.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kiosk-metrics",
    transform: "translate(84.000000, 880.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-ID-",
    transform: "translate(20.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FR",
    transform: "translate(11.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/person/grey",
    transform: "translate(0.000000, 1.851852)",
    fill: "#BCBCBC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,30.1286316 C26.9700747,30.1286316 30.2275272,30.5610957 33.7724551,31.4260368 C37.7964273,32.4351348 41.0538798,33.7805786 43.5449102,35.4624085 C46.5149849,37.4325522 48,39.6429241 48,42.0935906 L48,48.1481481 L7.10542736e-15,48.1481481 L7.10542736e-15,42.0935906 C7.10542736e-15,39.6429241 1.48501509,37.4325522 4.45508982,35.4624085 C6.94612024,33.7805786 10.2035727,32.4351348 14.2275449,31.4260368 C17.7724728,30.5610957 21.0299253,30.1286316 24,30.1286316 Z M24,24.0740741 C21.8443006,24.0740741 19.8562965,23.533494 18.0359281,22.4523176 C16.2155598,21.3711412 14.7664725,19.9175814 13.6886228,18.0915946 C12.6107731,16.2656078 12.0718563,14.2714679 12.0718563,12.1091151 C12.0718563,9.94676231 12.6107731,7.92859664 13.6886228,6.05455755 C14.7664725,4.18051846 16.2155598,2.70293288 18.0359281,1.62175649 C19.8562965,0.54058009 21.8443006,0 24,0 C26.1556994,0 28.1437035,0.54058009 29.9640719,1.62175649 C31.7844402,2.70293288 33.2335275,4.18051846 34.3113772,6.05455755 C35.3892269,7.92859664 35.9281437,9.94676231 35.9281437,12.1091151 C35.9281437,14.2714679 35.3892269,16.2656078 34.3113772,18.0915946 C33.2335275,19.9175814 31.7844402,21.3711412 29.9640719,22.4523176 C28.1437035,23.533494 26.1556994,24.0740741 24,24.0740741 Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#BCBCBC",
    strokeWidth: 0.925925926,
    points: "15.0905739 0 7.65674901 0 7.65674901 7.68075061"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy",
    stroke: "#BCBCBC",
    strokeWidth: 0.925925926,
    transform: "translate(36.346831, 3.840375) rotate(-270.000000) translate(-36.346831, -3.840375) ",
    points: "40.075215 0.0118165394 32.6184463 0.0118165394 32.6184463 7.66893407"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy-2",
    stroke: "#BCBCBC",
    strokeWidth: 0.925925926,
    transform: "translate(36.346831, 25.406004) rotate(-180.000000) translate(-36.346831, -25.406004) ",
    points: "40.0637431 21.5656285 32.6299182 21.5656285 32.6299182 29.2463791"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy-3",
    stroke: "#BCBCBC",
    strokeWidth: 0.925925926,
    transform: "translate(12.248993, 25.406004) rotate(-90.000000) translate(-12.248993, -25.406004) ",
    points: "15.9773774 21.577445 8.52060863 21.577445 8.52060863 29.2345625"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-/-matched-photo",
    transform: "translate(37.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 7.5,
    cy: 7.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58653846,10.5168269 L11.8966346,4.20673077 L10.9038462,3.18028846 L5.58653846,8.51442308 L3.09615385,6.00721154 L2.10336538,7 L5.58653846,10.5168269 Z M7,0 C8.27885255,0 9.4623343,0.319708341 10.5504808,0.959134615 C11.6049732,1.56490688 12.4350931,2.39502678 13.0408654,3.44951923 C13.6802917,4.5376657 14,5.72114745 14,7 C14,8.27885255 13.6802917,9.4623343 13.0408654,10.5504808 C12.4350931,11.6049732 11.6049732,12.4350931 10.5504808,13.0408654 C9.4623343,13.6802917 8.27885255,14 7,14 C5.72114745,14 4.5376657,13.6802917 3.44951923,13.0408654 C2.39502678,12.4238751 1.56490687,11.5881463 0.959134615,10.5336538 C0.319708341,9.44550738 0,8.26763454 0,7 C0,5.73236546 0.319708341,4.55449262 0.959134615,3.46634615 C1.57612488,2.4118537 2.4118537,1.57612488 3.46634615,0.959134615 C4.55449262,0.319708341 5.73236546,0 7,0 Z",
    id: "Success-icon",
    fill: "#8BC34A",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceRecognizedIcon);
export default __webpack_public_path__ + "static/media/face_recognized_icon.83f5a7b2eb5fe68298eb399da957a5c6.svg";
export { ForwardRef as ReactComponent };